export enum UnitEnum {
  QUANTITY = 1,
  KILOGRAM = 3,
  SQUARE_METERS = 5,
  METER = 6,
  CENTIMETER = 7

}

export const UnitEnumValues: number[] = [UnitEnum.QUANTITY, UnitEnum.KILOGRAM, UnitEnum.SQUARE_METERS, UnitEnum.METER, UnitEnum.CENTIMETER]
export const UnitEnumForEditableValues: number[] = [UnitEnum.KILOGRAM, UnitEnum.SQUARE_METERS, UnitEnum.METER, UnitEnum.CENTIMETER]
